import axios from "axios";
import * as Constants from "../constant";

const updateUserProfile = async (formData, UserId) => {
	try {
		const response = await axios.patch(
			`${Constants?.LOCAL_URL}/addresses/${UserId}`,
			formData
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
export default updateUserProfile;
